import { isValidMoment,US_DATE_FORMAT,formatMomentObjectWithValue } from '../../../Utils/dateUtil';

const validate = (values,props) => {
    const errors = {};
    let requiredFields = [
        'hdrVendorCode',
        'hdrMainAcctNo',
        'hdrCustCompName',
      ];

    const { projApollo,jwt } = props;

    if (!values.isPdfIssue){
        if (!values.isOverrideHdrMainInvNoIfNotFound){
            requiredFields.push('hdrMainInvNo')
        }
        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'This field is required'
            }
        })

        
        const { validatedVendorCode, validatedAcctNo, docTemplLines, invoiceVendor, invoiceVendors} = projApollo;
        if (values['hdrVendorCode']){
            if (!invoiceVendor){
                props.selectedInvVendor(values['hdrVendorCode'],invoiceVendors);
                props.refreshAcctNos(jwt,values['hdrVendorCode']);
                props.refreshCustNames(jwt,values['hdrVendorCode']);
                props.refreshChargeDescs(jwt,values['hdrVendorCode']);
                props.refreshServiceAddress(jwt,values['hdrVendorCode']);
                props.clearAllInvoiceItems();
            }else {
                if (values['hdrVendorCode']!== invoiceVendor.code){
                    props.selectedInvVendor(values['hdrVendorCode'],invoiceVendors);
                }
            }
        }else {
            props.clearInvVendor();
            props.clearInvAcctNo();
        }

        if (values['hdrMainAcctNo']){
            if (!projApollo.invAcctNo || projApollo.invAcctNo !== values['hdrMainAcctNo']){
              props.setInvAcctNo(values['hdrMainAcctNo']);
              props.refreshCustNames(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
              props.refreshChargeDescs(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
              props.refreshServiceAddress(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
            }
        }
        
        if (projApollo.validatedVendorNAcctNo && projApollo.validateError){
            const { field, error,value } = projApollo.validateError;
            if (values[field]!== value ) {
                props.clearValidation();
            }
        }

        if (validatedVendorCode && validatedAcctNo && values['hdrCustCompName']){
            let search = docTemplLines.find(x=>x.inv_prop_id_val===values['hdrCustCompName']);
            if (!search){
                errors['hdrCustCompName'] = 'Invalid Customer Company Name!'
            }
        }

        if (projApollo.validateError) {
            const { field, error,value } = projApollo.validateError;
            errors[field] = error;
        }
    }  
    
    if (values.hdrInvDate && !isValidMoment(values.hdrInvDate)){
        errors.hdrInvDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }
    
    if (values.hdrPayDate && !isValidMoment(values.hdrPayDate)){
        errors.hdrPayDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }

    let addFieldErrors =[]
    let clearFieldErrors = []
    //Validate Invoice Date cannot have same value with Payment Date
    if (values.hdrInvDate && values.hdrPayDate ){
        const invDate = formatMomentObjectWithValue(values.hdrInvDate,US_DATE_FORMAT)
        const payDate = formatMomentObjectWithValue(values.hdrPayDate,US_DATE_FORMAT)

        if (invDate === payDate){
            errors.hdrInvDate = "Header's Invoice Date cannot have same value with Payment Date"
            errors.hdrPayDate = "Header's Payment Date cannot have same value with Invoice Date"
        }
    }
    
    //Validate Invoice Date with item's billing start date
    if (values.hdrInvDate){
        const invDate = formatMomentObjectWithValue(values.hdrInvDate,US_DATE_FORMAT)
        const items = projApollo.apolloItems.filter(item =>  {
            return item.item_bill_start_date &&  invDate === item.item_bill_start_date
        })
        if (items.length > 0){
            const item = items[0]
            errors.hdrInvDate = `Header's Invoice Date has detected same value in item row ${item.item_row_index}'s billing start date`
        }
    }

    //Validate Payment Date with item's billing end date
    if (values.hdrPayDate){
        const payDate = formatMomentObjectWithValue(values.hdrPayDate,US_DATE_FORMAT)
        const items = projApollo.apolloItems.filter(item =>  {
            return item.item_bill_end_date &&  payDate === item.item_bill_end_date
        })
        if (items.length > 0){
            const item = items[0]
            errors.hdrPayDate = `Header's Payment Date has detected same value in item row ${item.item_row_index}'s billing end date`
        }
    }

    if (errors.hdrInvDate){
        addFieldErrors.push('hdrInvDate')
    }
    if (errors.hdrPayDate){
        addFieldErrors.push('hdrPayDate')
    }

    if (!errors.hdrInvDate && projApollo.fieldErrors.indexOf('hdrInvDate')>=0){
        clearFieldErrors.push('hdrInvDate')
    }
    if (!errors.hdrPayDate && projApollo.fieldErrors.indexOf('hdrPayDate')>=0){
        clearFieldErrors.push('hdrPayDate')
    }
    if (props.isOverrideInvDate){
        errors.hdrInvDate = ''
    }
    if (props.isOverridePayDate){
        errors.hdrPayDate = ''
    }
    props.updateFieldError(addFieldErrors,clearFieldErrors)
    
    
    return errors;
}

const validateAddNewItem = (values,props) => {
    const errors = {};
    const { isOverrideColPServiceAddress,projApollo,hdrInvDate,hdrPayDate }=props;
    
    let requiredFields = [
        'colLChargeDesc',
        'colMCharge'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })

    if (values.colQBillingStartDate && !isValidMoment(values.colQBillingStartDate)){
        errors.colQBillingStartDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }
    if (values.colRBillingEndDate && !isValidMoment(values.colRBillingEndDate)){
        errors.colRBillingEndDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }

    if (values.colQBillingStartDate && values.colRBillingEndDate){
        if (values.colQBillingStartDate.isAfter(values.colRBillingEndDate)){
            errors['colQBillingStartDate'] = 'This date is greater than end date'
            errors['colRBillingEndDate'] = 'This date is less than start date'
        }
    }

    let addFieldErrors =[]
    let clearFieldErrors = []
    let validateWithHeader = false
    //Validate Billing Start Date cannot have same value as in Header's Invoice Date
    if (values.colQBillingStartDate && hdrInvDate){
        const invDate = formatMomentObjectWithValue(hdrInvDate,US_DATE_FORMAT)
        const colQBillingStartDate = formatMomentObjectWithValue(values.colQBillingStartDate,US_DATE_FORMAT)

        if (invDate === colQBillingStartDate){
            validateWithHeader = true
            errors.colQBillingStartDate = "Billing Start Date is cannot have same value as in Header's Invoice Date"
        }
    }

    //Validate Billing End Date cannot have same value as in Header's Payment Date
    if (values.colRBillingEndDate && hdrPayDate){
        const payDate = formatMomentObjectWithValue(hdrPayDate,US_DATE_FORMAT)
        const colRBillingEndDate = formatMomentObjectWithValue(values.colRBillingEndDate,US_DATE_FORMAT)
        
        if (payDate === colRBillingEndDate){
            validateWithHeader = true
            errors.colRBillingEndDate = "Billing End Date is cannot have same value as in Header's Payment Date"
        }
    }

    if (validateWithHeader && errors.colQBillingStartDate){
        addFieldErrors.push('colQBillingStartDate')
    }
    if (validateWithHeader && errors.colRBillingEndDate){
        addFieldErrors.push('colRBillingEndDate')
    }

    if (!errors.colQBillingStartDate && projApollo.fieldErrors.indexOf('colQBillingStartDate')>=0){
        clearFieldErrors.push('colQBillingStartDate')
    }
    if (!errors.colRBillingEndDate && projApollo.fieldErrors.indexOf('colRBillingEndDate')>=0){
        clearFieldErrors.push('colRBillingEndDate')
    }

    if (props.isOverrideBillStartDate || (projApollo.apolloItem && projApollo.apolloItem.isOverrideBillStartDate)){
        errors.colQBillingStartDate = ''
    }
    if (props.isOverrideBillEndDate || (projApollo.apolloItem && projApollo.apolloItem.isOverrideBillEndDate)){
        errors.colRBillingEndDate = ''
    }
    props.updateFieldError(addFieldErrors,clearFieldErrors)

    if (!props.isOverrideColPServiceAddress && values['colPServiceAddress']){
        const { invItemServiceAddrs } = projApollo;
        let search = invItemServiceAddrs.find(x=> x.code ===values['colPServiceAddress']);
        if (!search){
            errors['colPServiceAddress'] = 'Invalid Service Address!'
        }   
    }

    return errors;
}

exports.validate=validate
exports.validateAddNewItem=validateAddNewItem


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/others/validation.js